// import * as pcj from '../../../package.json';

export const environment = {
  production: true,
  baseUrl: 'https://stage.mon.z2s.ru/mobile/',
  publicUrl: '',
  apiUrl: 'api/v1/',
  // version: pcj.version,
};
